const multipliers = [6, 5, 7, 2, 3, 4, 5, 6, 7]

const nip = (arg) => {
    let numbers = arg.replace(/-/g, '')
    let sum = 0
    if(numbers.length !== 10) {
        return false
    }
    for (let i = 0; i < 9; i++) {
        let number = parseInt(numbers.charAt(i))
        sum += number * multipliers[i]
    }
    if(parseInt(numbers.charAt(9)) === sum % 11) {
        return true
    }
    return false
}

export default nip
